import { Config } from 'aws-sdk';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { clearRoutes } from '../actions/getRoutes';

function logout(config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  Config.region = config.region;

  const prom = new Promise((resolve, reject) => {
    const user = userPool.getCurrentUser();
    Config.region = config.region;
    if (!user) {
      reject(new Error('User not found'));
      forceLogout();
    } else {
      user.signOut();
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem('signedout', true);
      resolve('signed out');
    }
  });

  return prom;
}

//Force a logout if the currentUser cannot be found
//When attempting a logout.
function forceLogout() {
  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem('signedout', true);
  //refresh to force user back to login page.
  window.href = window.href;
};

export const clearPerson = dispatch => dispatch({ type: 'PERSON_FETCH_FULFILLED', payload: { data: { person : null } } });

export default function signOut(config) {
  return dispatch => dispatch({
    type: 'SIGNOUT_USER_FETCH',
    payload: logout(config),
  }).then(() => clearPerson(dispatch))
  .catch((error) => {
    // just swallow this error, it means that the user is already logged out.
  }).then(() => clearRoutes(dispatch))
    .catch((error) => {
      // just swallow this error, it means that the user is already logged out.
    });
}



// WEBPACK FOOTER //
// ./src/actions/signOut.js